import { useTranslation } from "react-i18next";

import { GlobalLocationState } from "../../../../commons/types/location";
import * as icons from "../../../../resources/icons";
import Icon from "../../../commons/components/Icon/Icon";
import IconLink from "../../../commons/components/IconLink/IconLink";
import CommonProductFinderPartial from "../../../commons/container/ProductFinder/ProductFinderPartial";
import { useAppHistory, useAppLocation } from "../../../commons/libs/hooks/use-app-routing";
import { ROUTES } from "../../../commons/routes";
import { useMobileAppDispatcher, useMobileAppSelector } from "../../store/hooks";

const ProductFinderPartial = () => {
  const hasEnteredThroughDeepLink = useMobileAppSelector(state => state.mobile?.hasEnteredThroughDeepLink);
  const [dispatch, actions] = useMobileAppDispatcher();
  const { t } = useTranslation(["mobile"]);
  const history = useAppHistory();
  const location = useAppLocation();

  const renderBackButton = () => {
    const onClick = () => {
      // To prevent a mobile user from accidentally exiting the app when he enters through a deep link,
      // we redirect in place (don't push), to the main page to start a new history
      if (hasEnteredThroughDeepLink) {
        // We reset the hasEnteredThroughDeepLink-state to prevent a loop
        dispatch(actions.mobile.setHasEnteredThroughDeepLink(false));
        history.replace(ROUTES.NAVIGATION.INDEX);
      } else if (location.state?.goBackToDetails) {
        const locationState: GlobalLocationState = {
          ...{
            ...(location.state || {}),
            // active filters are removed from location state because between the details and the overview the session state is the source of truth
            activeFilters: undefined
          },
          goBackToDetails: true
        };
        history.replace(ROUTES.PRODUCT_FINDER_OVERVIEW.DETAILS, locationState);
      } else {
        history.goBack();
      }
    };

    const label = hasEnteredThroughDeepLink
      ? t("mobile:productFinder.backToMainMenuButton")
      : (location.state?.backLabel ?? t("mobile:productFinder.backButton"));

    return (
      <IconLink onClick={onClick} icon={<Icon source={icons.IconSmallArrowLeft} />} size="l">
        {label}
      </IconLink>
    );
  };

  return <CommonProductFinderPartial backButton={renderBackButton} isOffline={false} />;
};

export default ProductFinderPartial;
